/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonsunsaved2Inputs */

const en_listingbuttonsunsaved2 = /** @type {(inputs: Listingbuttonsunsaved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsaved changes`)
};

const de_listingbuttonsunsaved2 = /** @type {(inputs: Listingbuttonsunsaved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht gespeicherte Änderungen`)
};

/**
* | output |
* | --- |
* | "Unsaved changes" |
*
* @param {Listingbuttonsunsaved2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonsunsaved2 = /** @type {((inputs?: Listingbuttonsunsaved2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonsunsaved2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonsunsaved2(inputs)
	return de_listingbuttonsunsaved2(inputs)
});
export { listingbuttonsunsaved2 as "listingButtonsUnsaved" }